import { delay } from '../utils';

export async function focusError(): Promise<void> {
  await delay(300);
  const el: HTMLElement | null = document.querySelector<HTMLElement>(
    '[data-error="error"]'
  );
  if (!el) return;
  if (el.scrollIntoView) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }
  el.focus?.();
}
